<template>
  <div id="myChart"
       style="width:100%;height:100%;"></div>
</template>
<script>
import echarts from "echarts";
require("echarts/lib/component/tooltip"); // tooltip组件
require("echarts/lib/component/title"); //  title组件
require("echarts/lib/component/legend");
require("echarts/lib/chart/line");
export default {
  name: "lineChart",
  props: ["xData", "x", "y", "interval", 'width', 'height', 'series'],
  //series=[{name:"名称",data:[1,2,3,45,4,5,4,1]}]
  //[xData：x轴底部数据，x:x轴名称，y：y轴名称，series：具体数据，inverval:底部坐标间隔]
  // watch: {
  //   seriesData: {
  //     handler(newName, oldName) {
  //       // ...
  //     },
  //     deep: true,
  //     immediate: true
  //   }
  // },
  data () {
    return {
      option: {
        legend: {
          data: [],
          textStyle: {
            //图例文字的样式
            color: "#fff",
            fontSize: 12 * this.$store.state.ratio.hole,
          }
        },
        grid: {
          // 控制图的大小，调整下面这些值就可以，
          x: "15%",
          x2: "15%",
          y2: '25%',// y2可以控制 X轴跟Zoom控件之间的间隔，避免以为倾斜后造成 label重叠到zoom上
          y: '20%'
        },
        xAxis: {
          type: "category", // 还有其他的type
          data: [],
          name: "", // x轴名称
          // x轴名称样式
          axisLabel: {
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff", //刻度线标签颜色
            interval: 0
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 2,
            }
          },
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          }
        },

        yAxis: {
          type: "value",
          name: "", // y轴名称
          // y轴名称样式
          axisLabel: {
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff" //刻度线标签颜色
          },
          axisLine: {
            lineStyle: {
              color: '#fff',
              width: 2 * this.$store.state.ratio.hole,
            }
          },
          nameTextStyle: {
            fontWeight: 600,
            fontSize: 12 * this.$store.state.ratio.hole,
            color: "#fff"
          }
        },
        label: {},
        tooltip: {
          trigger: "axis" // axis   item   none三个值
        },
        series: [],
        color: [
          "RGBA(239, 115, 122, 1)",
          "RGBA(141, 255, 255, 1)",
          "RGBA(125, 157, 243, 1)",
          "RGBA(255, 254, 210, 1)"
        ]
      }
    };
  },
  mounted () {
    this.drawLineChart();
  },
  watch: {

    series: {
      handler: function () {
        this.drawLineChart();
      },
      deep: true    }
  },

  methods: {
    //渲染DIV为折线图
    drawLineChart () {
      let myChart = echarts.init(this.$el);
      myChart.getDom().style.height = this.height
      myChart.getDom().style.width = this.width
      this.attributeProcessing();
      myChart.setOption(this.option, true);
    },
    //父组件的参数传入时对option的处理
    attributeProcessing () {
      this.option.xAxis.data = this.xData || [0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24];
      this.option.xAxis.name = this.x || "时";
      this.option.yAxis.name = this.y || "";
      this.handleSeries();
    },
    //对父组件参入的数据进行处理
    handleSeries () {
      if (this.series) {
        let legend = [];

        this.series.forEach(item => {
          item.type = "line";
          legend.push(item.name);
        });
        this.option.series = this.series || [];
        this.option.legend.data = legend || [];

        let itemStyle = {
          normal: {
            lineStyle: {
              color: ""
            }
          }
        };
        for (let i in this.option.series) {
          this.option.series[i].itemStyle = JSON.parse(
            JSON.stringify(itemStyle)
          );
          if (i % 4 == 1) {
            this.option.series[i].itemStyle.normal.lineStyle.color =
              "RGBA(141, 255, 255, 1)";
          }
          if (i % 4 == 2) {
            this.option.series[i].itemStyle.normal.lineStyle.color =
              "RGBA(125, 157, 243, 1)";
          }
          if (i % 4 == 3) {
            this.option.series[i].itemStyle.normal.lineStyle.color =
              "RGBA(255, 254, 210, 1)";
          }
          if (i % 4 == 0) {
            this.option.series[i].itemStyle.normal.lineStyle.color =
              "RGBA(239, 115, 122, 1)";
          }
        }
      }

      if (this.interval) {
        this.option.xAxis.axisLabel.interval = this.interval;
      }
    }
  }
};
</script>
<style scoped>
canvas {
  width: 100%;
}
</style>
